/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: y4sqVQUkHUcQ
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import ButtonDock from "../../ButtonDock"; // plasmic-import: utQE8oqBBjiK/component
import { _useStyleTokens } from "../o_21_p_0_0_0_prod/PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "../o_21_p_0_0_0_prod/plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicWebDockMobil.module.css"; // plasmic-import: y4sqVQUkHUcQ/css
import Icon30Icon from "../o_21_p_0_0_0_prod/icons/PlasmicIcon__Icon30"; // plasmic-import: v-1PLPXOc6tO/icon
import Icon23Icon from "../o_21_p_0_0_0_prod/icons/PlasmicIcon__Icon23"; // plasmic-import: YwlgzG5yARIP/icon
import Icon34Icon from "../o_21_p_0_0_0_prod/icons/PlasmicIcon__Icon34"; // plasmic-import: 3VA-qZnm8pUB/icon
import Icon15Icon from "../o_21_p_0_0_0_prod/icons/PlasmicIcon__Icon15"; // plasmic-import: KZeS8_m5UsgE/icon
import Icon27Icon from "../o_21_p_0_0_0_prod/icons/PlasmicIcon__Icon27"; // plasmic-import: WzMsUn33Iqfb/icon
import Icon26Icon from "../o_21_p_0_0_0_prod/icons/PlasmicIcon__Icon26"; // plasmic-import: flPWDcL8BgpD/icon

createPlasmicElementProxy;

export const PlasmicWebDockMobil__VariantProps = new Array("isCollapsed");

export const PlasmicWebDockMobil__ArgProps = new Array("modulesWrapper");

const $$ = {};

function PlasmicWebDockMobil__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "isCollapsed",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isCollapsed
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"dock"}
      data-plasmic-override={overrides.dock}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.dock,
        {
          [sty.dockisCollapsed]: hasVariant(
            $state,
            "isCollapsed",
            "isCollapsed"
          )
        }
      )}
      onMouseEnter={async event => {
        const $steps = {};
      }}
      onMouseLeave={async event => {
        const $steps = {};
      }}
    >
      <div
        data-plasmic-name={"buttonsWrapp"}
        data-plasmic-override={overrides.buttonsWrapp}
        className={classNames(projectcss.all, sty.buttonsWrapp, {
          [sty.buttonsWrappisCollapsed]: hasVariant(
            $state,
            "isCollapsed",
            "isCollapsed"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: (
            <React.Fragment>
              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__y0Rm3)}
                color={"light"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox__uufNa)}
                  >
                    <Icon30Icon
                      className={classNames(projectcss.all, sty.svg__qAjQe)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />

              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__nYfbv)}
                color={"light"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox__qhePv)}
                  >
                    <Icon23Icon
                      className={classNames(projectcss.all, sty.svg__dqqCn)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />

              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__qiFow)}
                color={"light"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox__fOpFn)}
                  >
                    <Icon34Icon
                      className={classNames(projectcss.all, sty.svg__fFaFc)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />

              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__uu1CM)}
                color={"light"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox___7N0NQ)}
                  >
                    <Icon15Icon
                      className={classNames(projectcss.all, sty.svg___32N1O)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />

              <div className={classNames(projectcss.all, sty.freeBox___9F519)}>
                <div
                  className={classNames(projectcss.all, sty.freeBox__jhulv)}
                />
              </div>
              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__ln8Xj)}
                color={"dark"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox___8GPgr)}
                  >
                    <Icon27Icon
                      className={classNames(projectcss.all, sty.svg__lBnZ)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />

              <ButtonDock
                className={classNames("__wab_instance", sty.buttonDock__yQRtQ)}
                color={"dark"}
                iconTab={
                  <div
                    className={classNames(projectcss.all, sty.freeBox__mxeSy)}
                  >
                    <Icon26Icon
                      className={classNames(projectcss.all, sty.svg__yRlg)}
                      role={"img"}
                    />
                  </div>
                }
                status={"_default"}
              />
            </React.Fragment>
          ),

          value: args.modulesWrapper
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  dock: ["dock", "buttonsWrapp"],
  buttonsWrapp: ["buttonsWrapp"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebDockMobil__ArgProps,
          internalVariantPropNames: PlasmicWebDockMobil__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebDockMobil__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "dock") {
    func.displayName = "PlasmicWebDockMobil";
  } else {
    func.displayName = `PlasmicWebDockMobil.${nodeName}`;
  }
  return func;
}

export const PlasmicWebDockMobil = Object.assign(
  // Top-level PlasmicWebDockMobil renders the root element
  makeNodeComponent("dock"),
  {
    // Helper components rendering sub-elements
    buttonsWrapp: makeNodeComponent("buttonsWrapp"),
    // Metadata about props expected for PlasmicWebDockMobil
    internalVariantProps: PlasmicWebDockMobil__VariantProps,
    internalArgProps: PlasmicWebDockMobil__ArgProps
  }
);

export default PlasmicWebDockMobil;
/* prettier-ignore-end */
